<h2 mat-dialog-title>
  <mat-icon> bookmark </mat-icon>
  {{ data.type == 'create' ? 'Nuevo ' + data.module : 'Actualización de ' + data.module }}
</h2>
<mat-dialog-content class="mat-typography">

  <div class="input-item-form" [formGroup]="formGroup">
    @for (input of inputs; track input) {
      <div class="input-container">
        @if (input['type'] !== 'select') {
          <mat-form-field appearance="outline">
            <mat-label>{{ input['displayName'] }}</mat-label>
            <input matInput [type]="input['type']" [formControlName]="input['name']">
          </mat-form-field>
        }
        @if (input['type'] == 'select') {
          <mat-form-field appearance="outline">
            <mat-label>{{ input['displayName'] }}</mat-label>
            <mat-select [formControlName]="input['name']">
              @for (option of input['options']; track option) {
                <mat-option matTooltipPosition="right" [matTooltip]="option.name" [value]="option.id">
                  {{option.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>
    }
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancelar</button>
  @if (data.type == 'create') {
    <button mat-raised-button color="primary" (click)="create()"> Guardar </button>
  }
  @if (data.type == 'update') {
    <button mat-raised-button color="primary" (click)="update()"> Guardar </button>
  }
</mat-dialog-actions>
